import React, { ReactNode } from "react";
import IField from "../../../../interfaces/field";
import { ErrorMsg, Label } from "../../../ui";
import DependencyValidator from "../dependency-validator";

import { Container, Wrapper, Content } from "./styles";

type IProps = any &
  IField & {
    children: ReactNode;
  };

const TplGroup: React.FC<IProps> = ({
  name,
  prefixName,
  title,
  children,
  required,
  ...el
}: IProps) => (
  <Content>
    <DependencyValidator name={name} prefixName={prefixName} {...el}>
      <Container style={{ ...el.styleContainer }}>
        {title && (
          <Label
            htmlFor={name}
            isRegister={el?.optionsExtra?.isRegister || false}
            className="label"
          >
            {title}
            {required && <span>*</span>}
          </Label>
        )}
        <Wrapper>{children}</Wrapper>
        {el.dirty && el.touched[name] && <ErrorMsg>{el.errors[name]}</ErrorMsg>}
      </Container>
    </DependencyValidator>
  </Content>
);

export default TplGroup;
